import { render, staticRenderFns } from "./updateTableNumber.vue?vue&type=template&id=22fcb6de&scoped=true&"
import script from "./updateTableNumber.vue?vue&type=script&lang=js&"
export * from "./updateTableNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcb6de",
  null
  
)

export default component.exports